import { initProductCardSwitchers } from '../modules/ProductCard';

initProductCardSwitchers(document);
